import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FuseLoadingBarComponent } from '@fuse/components/loading-bar/loading-bar.component';
import { ProgressBarModule } from 'primeng/progressbar';

@NgModule({
    declarations: [
        FuseLoadingBarComponent
    ],
    imports     : [
        CommonModule,
        ProgressBarModule
    ],
    exports     : [
        FuseLoadingBarComponent
    ]
})
export class FuseLoadingBarModule
{
}
